"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateAndTimeMergeNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const date_fns_1 = require("date-fns");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'DATE-TIME-MERGE';
/**
 * This ugly code is used to get the start of the UTC day. Teh startOfDay function from
 * date-fns takes calculates with the time zone, which breaks from the way we handle dates and times
 * in forms
 * @param date date to get start of day for
 */
const startOfDay = (date) => {
    if (date && date.toJSON()) {
        // take the date in the UTC format, 0 out the time and reutnr a new Date
        const regex = /(\d\d\d\d-\d\d-\d\d).*Z/;
        return new Date(date.toJSON().replace(regex, '$1T00:00:00.000Z'));
    }
    return new Date(0);
};
class DateAndTimeMergeNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            let dateNumber = 0;
            let timeNumber = 0;
            const { dateSource, timeSource } = params;
            if (dateSource && typeof dateSource === 'string') {
                const dateValue = date_fns_1.parseJSON(dateSource);
                dateNumber = startOfDay(dateValue).getTime();
            }
            if (timeSource && typeof timeSource === 'string') {
                const timeValue = date_fns_1.parseJSON(timeSource);
                timeNumber = (timeValue.getTime() || 0) - startOfDay(timeValue).getTime();
            }
            const finalDate = dateNumber + timeNumber;
            return { [`output`]: new Date(finalDate || 0) };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.DateAndTimeMergeNode = DateAndTimeMergeNode;
DateAndTimeMergeNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Date and Time Merge',
    isIdempotent: true,
    primaryCategory: 'Date/Time',
};
//# sourceMappingURL=DateAndTimeMerge.js.map